module.exports = __webpack_public_path__ + "img/cross.ba640846.svg";